export const renderTag = (tag, isLast) => (isLast ? tag : `${tag}, `);
